import React from 'react'; // eslint-disable-line
import { put, select } from 'redux-saga/effects';
import { generateId } from '../utils';

import * as actions from '../state';
import createBoardService from './services/board/createBoard';
import fetchBoardListService from './services/board/fetchBoardList';

export default function* createBoard(event) {
  const user = yield select((state) => actions.readStateUser(state));
  const appURL = yield select((state) => actions.selectConfig(state, 'appURL'));

  const { intl } = event.payload;
  const { messages } = event.payload;

  const newBoard = {
    name: intl.formatMessage({ ...messages.NEW_BOARD }),
    domain: user.domain,
    layouts: {
      lg: [{
        w: 6,
        h: 4,
        x: 0,
        y: 0,
        moved: false,
        static: false,
      }],
    },
    public_id: generateId(8),
  };

  const newBoardId = yield createBoardService({
    user: user.userId,
    domain: user.domain,
    board: newBoard,
  });

  newBoard.id = newBoardId;
  const newPath = appURL + newBoardId;
  window.history.pushState({ urlPath: newPath }, '', newPath);

  const boardList = yield fetchBoardListService({ domain: user.domain });

  yield put(actions.setBoardList(boardList));
  yield put(actions.setCharts([]));
  yield put(actions.setBoard(newBoard));
  yield put(actions.editMode(true));
  yield put(actions.isLoading(false));
}
